module.exports = __webpack_public_path__ + "img/img_6.7a09cd26.jpeg";